var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 29,
    viewBox: "0 0 20 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84846 0C1.90964 0 0.333313 1.62559 0.333313 3.625V25.375C0.333313 27.3744 1.90964 29 3.84846 29H16.1515C18.0903 29 19.6666 27.3744 19.6666 25.375V3.625C19.6666 1.62559 18.0903 0 16.1515 0H3.84846ZM8.2424 24.4688H11.7576C12.2409 24.4688 12.6363 24.8766 12.6363 25.375C12.6363 25.8734 12.2409 26.2812 11.7576 26.2812H8.2424C7.75907 26.2812 7.36362 25.8734 7.36362 25.375C7.36362 24.8766 7.75907 24.4688 8.2424 24.4688Z",
    fill: "#5AB2AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelular);
export default __webpack_public_path__ + "static/media/celular.5cf47a30b1505d3cc5cb14c6726bd02c.svg";
export { ForwardRef as ReactComponent };